import { DeliveryStatus } from '../models/Order';

const translateDeliveryStatus = (status: DeliveryStatus) => {
  switch (status) {
    case DeliveryStatus.PENDING:
      return 'Oczekujące';
    case DeliveryStatus.READY:
      return 'Gotowe do wysłania';
    case DeliveryStatus.SHIPPED:
      return 'Wysłane';
    case DeliveryStatus.DELIVERED:
      return 'Dostarczone';
    default:
      return status;
  }
};

export default translateDeliveryStatus;
